import { formatCrumbTestHook } from "../SharedRules";

export class Crumb {
    constructor(title, urlResult, selectedFilters) {
        this.title = title;
        this.testHook = formatCrumbTestHook(title);
        this.urlResult = urlResult;
        this.selectedFilters = selectedFilters;
    }
}
